<template>
    <div class="assetAppraiser">
        <div class="condition">
            <div class="item">
                <div class="label">查询:</div>
                <div class="input">
                    <el-input v-model="conditionData.Word" size="small" placeholder="请输入报案号/车牌/被保险人/物主/物损名称"></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">机构:</div>
                <div class="input">
                    <el-select v-model="conditionData.MechanismId" placeholder="请选择" size="small" @change="changeMechanismName">
                        <el-option
                        v-for="item in mechanismList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                    <!-- <el-input v-model="conditionData.Mechanism" size="small" placeholder="请输入"></el-input> -->
                </div>
            </div>
            <div class="item">
                <div class="label">作业人员:</div>
                <div class="input">
                    <el-input v-model="conditionData.Operator" size="small" placeholder="请输入"></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">案件类型:</div>
                <div class="input">
                    <!-- <el-cascader
                    v-model="conditionData.AssetsType"
                    :options="assetsTypeList"
                    size="small"
                    ></el-cascader> -->
                    <el-select v-model="conditionData.AssetsTypes" placeholder="请选择" size="small" multiple>
                        <el-option
                        v-for="item in assetsTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            
            
            <div class="item">
                <div class="label">事故地:</div>
                <div class="input">
                    <el-cascader
                    size="small"
                    :options="options"
                    v-model="selectedOptions"
                    @change="handleRegionChange">
                    </el-cascader>
                </div>

            </div>
            <div class="item">
                <div class="label">委托时间:</div>
                <el-date-picker
                v-model="conditionData.startTime"
                size="small"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
                </el-date-picker>
                ——
                <el-date-picker
                v-model="conditionData.endTime"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
                </el-date-picker>
            </div> 
            <!-- <div class="item">
                <div class="label">结束时间:</div>
                <el-date-picker
                v-model="conditionData.endTime"
                type="date"
                size="small"
                format="yyyy-MM-dd"
                placeholder="选择日期">
                </el-date-picker>
            </div> -->
            <div class="item">
                <div class="label">案件状态:</div>
                <div class="input">
                    <el-select v-model="conditionData.AssetsState" placeholder="请选择" size="small">
                        <el-option
                        v-for="item in assetsStateList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div> 
            <div class="item">
                <div class="label">财务状态:</div>
                <div class="input">
                    <el-select v-model="conditionData.FinancialState" placeholder="请选择" size="small">
                        <el-option
                        v-for="item in financialStateList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div> 
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">搜索</el-button>
                <el-button type="" size="small" @click="reset()">重置</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                
                <el-button type="primary" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <el-button type="success" icon="el-icon-download" size="small" @click="exportExcel()">导出excel</el-button>

            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                height="580px"
                style="width: 100%">

                <!-- <el-table-column
                prop="assetsTypeStr"
                label="案件类型"
                align="center"
                width="120px"
                >
                </el-table-column> -->
                <el-table-column
                prop="clientName"
                label="委托人"
                align="center"
                width="240px"
                >
                </el-table-column>
                <el-table-column
                prop="inCaseNo"
                label="报案号"
                align="center"
                width="190px"
                >
                </el-table-column>
                <el-table-column
                prop="caseName"
                label="案件名称"
                align="center"
                width="250px"
                >
                </el-table-column>
                <el-table-column
                prop="caseNo"
                label="报告编号"
                align="center"
                width="160px"
                >
                </el-table-column>
                <el-table-column
                prop="assetsStateStr"
                label="案件状态"
                align="center"
                width="110px"
                >
                </el-table-column>
                <el-table-column
                prop="financialState"
                label="财务状态"
                align="center"
                width="110px"
                >
                <template slot-scope="scope">
                    <span>{{scope.row.financialState==10?'已开票未回款':''}}</span>
                    <span>{{scope.row.financialState==15?'已开票部分回款':''}}</span>
                    <span>{{scope.row.financialState==20?'回款完成':''}}</span>
                    <span>{{scope.row.financialState==25?'已收款未开票':''}}</span>
                    <span>{{scope.row.financialState==0?'其他':''}}</span>
                </template>
                </el-table-column>
                <el-table-column
                prop="mechanism"
                label="作业机构"
                align="center"
                width="100px"
                >
                </el-table-column>
                <el-table-column
                prop="operator"
                label="作业人员"
                align="center"
                width="90px"
                >
                </el-table-column>
                <el-table-column
                prop="damageTime"
                label="事故日期"
                align="center"
                width="100px"
                >
                </el-table-column>
                <el-table-column
                prop="entrustDate"
                label="委托日期"
                align="center"
                width="100px"
                >
                </el-table-column>
                <el-table-column
                prop="creationTime"
                label="录入日期"
                align="center"
                width="100px"
                >
                </el-table-column>

                <el-table-column
                fixed="right"
                label="操作"
                width="200px"
                align="center"
                >
                <template slot-scope="scope">
                    <!-- <el-button type="text" icon="el-icon-edit" size="mini" @click="detail(scope.row,1,true)" v-if="scope.row.assetsState==10 || scope.row.assetsState==30 || scope.row.assetsState==45">编辑</el-button> -->

                    <el-button type="text" icon="el-icon-edit" size="mini" @click="detail(scope.row,1)" v-if="scope.row.assetsState==10&&(name==scope.row.operator)" >开始作业</el-button>
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="detail(scope.row,1)" v-if="(scope.row.assetsState==20||scope.row.assetsState==35)&&(name==scope.row.operator)">编辑提交</el-button>
                    <el-button type="text" icon="el-icon-download" size="mini" @click="createEntrust(scope.row)" v-if="scope.row.assetsState==20">委托书</el-button>
                    <!-- <el-button type="text" icon="el-icon-s-claim" size="mini" @click="report(scope.row)" v-if="scope.row.assetsState>30">生成报告</el-button> -->
                    <!-- <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="stamp(scope.row)" v-if="scope.row.assetsState==40||scope.row.assetsState==55">用印申请</el-button> -->
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="editCost(scope.row)" v-if="(scope.row.assetsState==64||scope.row.assetsState==40)&&(name==scope.row.operator)">编辑费用</el-button>
                    <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="detail(scope.row,0)">查看详情</el-button>
                    <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteAsset(scope.row)" v-if="role=='管理员'">删除</el-button>
                </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next"
                    :total="totalCount"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
                
            </div>
        </div>


        <el-dialog :visible.sync="isNoAccept" title="不受理" width="800px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        备注:
                    </div>
                    <div class="textarea">
                        <el-input v-model="remark" type="textarea" :rows="2" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="noAccept">确认提交</el-button>
                </div>
            </div>
        </el-dialog>


    </div>
</template>
<script>
import api from '../../../../api/main'
import {assetsTypeList,assetsStateList,FinancialStateList} from '../../../../assets/selectList/assetsSelectList'
import { provinceAndCityData , CodeToText } from "element-china-area-data";
export default {
    name: 'assetAppraiser',
    components:{
        
    },
    watch: {
    },
    data () {
        return {
            financialStateList:FinancialStateList,
            timeList:[],
            activeName:'全部',
            selectedOptions:[],
            area:[],
            title:'',
            isAddDialog:false,
            isUpdateDialog:false,
            totalCount:0,
            AssetsTypes:[],
            conditionData:localStorage.getItem('conditionData')?JSON.parse(localStorage.getItem('conditionData')):{
                Word:'',
                AssetsCaseType:3,
                AssetsTypes:[],
                MechanismId:'',
                Operator:'',
                AssetsState:'',
                CrimeCity:'',
                IsZCPG:true,
                startTime:'',
                endTime:'',
                FinancialState:null,
                page:1,
                pageSize:10,
            },

            tableData:[],
            options:provinceAndCityData,
            assetsType:[],
            
            assetsTypeList:[{
                value:4,
                label:'财产险'
            },{
                value:5,
                label:'车险'
            },{
                value:13,
                label:'其他调查'
            },],
            assetsStateList:assetsStateList,
            isNoAccept:false,
            remark:'',
            id:'',
            isEditFree:false,
            MechanismName:'',
            mechanismList:[],
            name:localStorage.getItem('name'),
            role:localStorage.getItem('roles'),
        }

    },
    created(){
        

    },
    mounted(){
        this.loadingData();
        this.getMechanismList();
    },
    methods:{
        changeMechanismName(e){
            console.log(e);
            for(let index in this.mechanismList){
                if(this.mechanismList[index].id==e){
                    this.MechanismName = this.mechanismList[index].name;
                    return;
                }
            }
        },
        async getMechanismList(){
            let res  = await api.QueryMechanism({});
            this.mechanismList = res.data.data.data;
        },
        
        deleteAsset(row){
            console.log(row);
            this.$confirm('确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteAsync(row.id);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        async deleteAsync(id){
            let res  = await api.deleteAsset(id);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                this.loadingData();
            }
        },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        // handleAssetsTypeChange(){
        //     console.log(this.assetsType);
        //     this.conditionData.AssetsType = this.assetsType[1];
        // },
        handleRegionChange(codeArray){
            console.log(codeArray);
            if(codeArray[0]){
                this.conditionData.Province = CodeToText[codeArray[0]]
            }
            if(codeArray[1]){
                this.conditionData.CrimeCity = CodeToText[codeArray[1]]
            }
            // if(codeArray[2]){
            //     this.conditionData.Area = CodeToText[codeArray[2]]
            // }
        },
        getDateYMD(date){
            let d = new Date(date);
            let year = d.getFullYear() > 9 ? d.getFullYear() : '0' + d.getFullYear();
            let month = (d.getMonth()+1) > 9 ? d.getMonth()+1 : '0' + (d.getMonth()+1);
            let day = d.getDate() > 9 ? d.getDate() : '0' + d.getDate();
            return year + '-' + month + '-' + day
        },
        getDate(date){
            let d = new Date(date);
            let year = d.getFullYear() > 9 ? d.getFullYear() : '0' + d.getFullYear();
            let month = (d.getMonth()+1) > 9 ? d.getMonth()+1 : '0' + (d.getMonth()+1);
            let day = d.getDate() > 9 ? d.getDate() : '0' + d.getDate();
            let h = d.getHours() > 9 ? d.getHours() : '0' + d.getHours();
            let m = d.getMinutes() > 9 ? d.getMinutes() : '0' + d.getMinutes();
            let s = d.getSeconds() > 9 ? d.getSeconds() : '0' + d.getSeconds();
            return year + '-' + month + '-' + day + ' ' + h + ':' + m + ':' + s
        },
        async loadingData() {
            console.log(this.timeList);
            if(this.timeList.length>0){
                this.conditionData.startTime = this.getDateYMD(this.timeList[0]);
            }
            if(this.timeList.length>1){
                this.conditionData.endTime = this.getDateYMD(this.timeList[1]);
            }
            let option = {
                Word:this.conditionData.Word,
                AssetsTypes:JSON.stringify(this.conditionData.AssetsTypes),
                AssetsStates:this.conditionData.AssetsState?JSON.stringify([this.conditionData.AssetsState]):'[]',
                CrimeCity:this.conditionData.CrimeCity,
                IsZCPG:this.conditionData.IsZCPG,
                AssetsCaseType:this.conditionData.AssetsCaseType,
                MechanismId:this.conditionData.MechanismId,
                Operator:this.conditionData.Operator,
                page:this.conditionData.page,
                pageSize:this.conditionData.pageSize,
                startTime:this.conditionData.startTime,
                endTime:this.conditionData.endTime,
                FinancialState:this.conditionData.FinancialState,
                Mechanism:this.MechanismName
            };
            let res  = await api.queryAssetsType(option);
            console.log(res);
            this.tableData = res.data.data.data;
            this.totalCount = res.data.data.totalCount;
            for(let index in this.tableData){
                this.tableData[index].damageTime = this.getDateYMD(this.tableData[index].damageTime);
                this.tableData[index].entrustDate = this.getDateYMD(this.tableData[index].entrustDate);
            }
        },
        selectData(){
            this.conditionData.page = 1;
            this.loadingData();
        },
        reset(){
            this.assetsType = [];
            this.timeList = [];
            this.MechanismName = '';

            this.conditionData = {
                Word:'',
                AssetsCaseType:3,
                AssetsTypes:[],
                MechanismId:'',
                Operator:'',
                AssetsState:'',
                CrimeCity:'',
                IsZCPG:true,
                startTime:'',
                endTime:'',
                FinancialState:null,
                page:1,
                pageSize:10,
            },
            this.selectedOptions=[];
            this.loadingData();
        },
        handleCurrentChange(page){
            this.conditionData.page = page;
            this.loadingData();
        },
        showAddDialog(){
            this.isAddDialog = true;
        },
        
        async isUpdateDialogShow(row){
            let res  = await api.QuryMechanismById({
                MechanismId:row.id
            });
            console.log(res);
            this.area = res.data.data.cityCode.split(',');
            this.isUpdateDialog = true;
            this.updateData = res.data.data;
        },
        detail(row,isEdit,isNoSubmit){
            localStorage.setItem('conditionData',JSON.stringify(this.conditionData))
            if(row.assetsType == 1){
                this.$router.push({
                    name:'materialDamage',
                    query:{
                        id:row.id,
                        isEdit:isEdit,
                        isNoSubmit:isNoSubmit?isNoSubmit:false
                    }
                });
            }else if(row.assetsType == 2){
                this.$router.push({
                    name:'carDamage',
                    query:{
                        id:row.id,
                        isEdit:isEdit,
                        isNoSubmit:isNoSubmit?isNoSubmit:false
                    }
                });
            }
            else if(row.assetsType == 3){
                this.$router.push({
                    name:'financeDamage',
                    query:{
                        id:row.id,
                        isEdit:isEdit,
                        isNoSubmit:isNoSubmit?isNoSubmit:false
                    }
                });
            }
            else if(row.assetsType == 4){
                this.$router.push({
                    name:'financeDamage',
                    query:{
                        id:row.id,
                        isEdit:isEdit,
                        isNoSubmit:isNoSubmit?isNoSubmit:false
                    }
                });
            }
            else if(row.assetsType == 5){
                this.$router.push({
                    name:'carInsuranceDamage',
                    query:{
                        id:row.id,
                        isEdit:isEdit,
                        isNoSubmit:isNoSubmit?isNoSubmit:false
                    }
                });
            }else{
                this.$router.push({
                    name:'financeDamage',
                    query:{
                        id:row.id,
                        isEdit:isEdit,
                        isNoSubmit:isNoSubmit?isNoSubmit:false
                    }
                });
            }
            
        },
        editCost(row){
            if(row.assetsType == 1){
                this.$router.push({
                    name:'materialDamage',
                    query:{
                        id:row.id,
                        isEditCost:true,
                    }
                });
            }else if(row.assetsType == 2){
                this.$router.push({
                    name:'carDamage',
                    query:{
                        id:row.id,
                        isEditCost:true,
                    }
                });
            }
            else if(row.assetsType == 3){
                this.$router.push({
                    name:'financeDamage',
                    query:{
                        id:row.id,
                        isEditCost:true,
                    }
                });
            }
            else if(row.assetsType == 4){
                this.$router.push({
                    name:'financeDamage',
                    query:{
                        id:row.id,
                        isEditCost:true,
                    }
                });
            }
            else if(row.assetsType == 5){
                this.$router.push({
                    name:'carInsuranceDamage',
                    query:{
                        id:row.id,
                        isEditCost:true,
                    }
                });
            }else{
                this.$router.push({
                    name:'financeDamage',
                    query:{
                        id:row.id,
                        isEditCost:true,
                    }
                });
            }
        },
        stamp(row,isEdit){
            if(row.assetsType == 1){
                localStorage.setItem('conditionData',JSON.stringify(this.conditionData))
                this.$router.push({
                    name:'materialDamage',
                    query:{
                        id:row.id,
                        isEdit:isEdit,
                        isStamp:true
                    }
                });
            }else if(row.assetsType == 2){
                this.$router.push({
                    name:'carDamage',
                    query:{
                        id:row.id,
                        isEdit:isEdit,
                        isStamp:true
                    }
                });
            }
            else if(row.assetsType == 3){
                this.$router.push({
                    name:'financeDamage',
                    query:{
                        id:row.id,
                        isEdit:isEdit,
                        isStamp:true
                    }
                });
            }
            else if(row.assetsType == 4){
                this.$router.push({
                    name:'financeDamage',
                    query:{
                        id:row.id,
                        isEdit:isEdit,
                        isStamp:true
                    }
                });
            }
            else if(row.assetsType == 5){
                this.$router.push({
                    name:'carInsuranceDamage',
                    query:{
                        id:row.id,
                        isEdit:isEdit,
                        isStamp:true
                    }
                });
            }else{
                this.$router.push({
                    name:'financeDamage',
                    query:{
                        id:row.id,
                        isEdit:isEdit,
                        isStamp:true
                    }
                });
            }
        },
        operate(row){
            console.log(row);
            this.id = row.id;
            if(row.yuGuFee<200&&row.yuGuFee){
                this.$message({
                    type: 'warning',
                    message: '预估金额不得小于200!'
                })
                return;
            }
            this.$confirm('是否开始作业此案件?', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.updateAssetsState(20);
                this.$message({
                    type: 'success',
                    message: '作业成功!'
                });
            }).catch(() => {
            });
        },
        // 取消
        cancel(row){
            this.id = row.id;
            this.$confirm('是否取消案件?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.updateAssetsState(0);
                this.$message({
                    type: 'success',
                    message: '取消成功!'
                });
            }).catch(() => {
                // this.$message({
                //     type: 'info',
                //     message: '已退回案件'
                // });   
            });
        },
        async updateAssetsState(state){
            console.log(state);
            console.log(this.id);
            let res = await api.UpdateAssetsState({
                "id": this.id,
                "assetsState": state,
                "remark": this.remark
            });
            this.loadingData();
        },
        noAccept(){
            this.updateAssetsState(-1);
            this.isNoAccept = false;
        },

        async report(row){
            if(row.assetsType == 1){
                this.$router.push({
                    name:'materialReport',
                    query:{
                        id:row.id,
                    }
                });
            }else if(row.assetsType == 2){
                this.$router.push({
                    name:'carReport',
                    query:{
                        id:row.id,
                    }
                });
            }
            
            else if(row.assetsType == 5){
                let r = await api.queryAssetsCarInsuranceResponse(row.id);
                let detail = r.data.data
                let imgList = [];

                for(let index in detail.assetsNalMap){
                    let isAddTitle = true;
                    for(let tindex in imgList){
                        if(imgList[tindex].Write == detail.assetsNalMap[index].assetsNulMapName){
                            isAddTitle = false;
                        }
                    }
                    if(imgList.length == 0){
                        imgList.push({
                            MoveToBookmark:'',
                            Write:detail.assetsNalMap[index].assetsNulMapName,
                            ImgBytes:[]
                        })
                    }else if(isAddTitle){
                        imgList.push({
                            MoveToBookmark:'',
                            Write:detail.assetsNalMap[index].assetsNulMapName,
                            ImgBytes:[]
                        })
                    }
                }
                for(let index in detail.assetsNalMap){
                    for(let tindex in imgList){
                        if(imgList[tindex].Write == detail.assetsNalMap[index].assetsNulMapName){
                            imgList[tindex].ImgBytes.push(detail.assetsNalMap[index].path)
                        }
                    }
                };
                //放弃索赔声明
                for(let index in imgList){
                    // console.log(imgList[index].Write.substring(0,4));
                    if(imgList[index].Write.indexOf('放弃索赔') != -1){
                        imgList[index].MoveToBookmark = 'Disclaimer'
                        imgList.push(imgList[index]);
                        imgList.splice(index,1);
                    }
                }
                // return;
                let option = {
                    "HomePageTime": this.CNDateString(),
                    "CompanyName": detail.assets.clientName,
                    "EntrustTime": detail.assets.entrustDate,
                    "PlaceOfDanger": detail.carInsurance.dangerAddress,
                    "CarBrand": detail.carInsurance.license,
                    "ThisCase": detail.assets.caseName,
                    "CaseInfo": detail.carInsurance.wtfh,
                    "EndPageTime": this.nowDate(),
                    "AccidentNO": detail.carInsurance.sgNumber,
                    "TimeOfDanger": detail.assets.damageTime,
                    "After": detail.carInsurance.dangerJg,
                    "Driver": detail.carInsurance.jsy,
                    "DispatchTime": detail.carInsurance.pgTime,
                    "PolicyNo": detail.carInsurance.policyNumber,
                    "TheInsured": detail.carInsurance.bbxr,
                    "BrandModel": detail.carInsurance.brand,
                    "FrameNo": detail.carInsurance.vehicleNo,
                    "PolicyDuration": this.nowDate(detail.carInsurance.bxdStartTime)+'——'+this.nowDate(detail.carInsurance.bxdEndTime),
                    "Safe": detail.carInsurance.bxje,
                    "Doubt": detail.carInsurance.wtsxjzayd,
                    "ExamineGoBy": '\n\n'+detail.carInsurance.dcjg,
                    "InsuranceLiability": detail.carInsurance.bxzr,
                    "InvestigationConclusion": '\n\n'+detail.carInsurance.dcjl,
                    "SubmitTime": this.nowDate(),
                    "Investigator": "",
                    "DataInfo": imgList
                }
                console.log(option);
                console.log(JSON.stringify(option));
                let res = await api.queryReport(option,row.caseName+'报告');
                console.log(res);
            }else{
                let res = await api.downLoadAsset({id:row.id},row.caseName+'报告');
            }
            
        },
        nowDate(d){
            let date
            if(d){
                date = new Date(d);
            }else{
                date = new Date();
            }
            let year = date.getFullYear();
            let month = date.getMonth()+1>9?date.getMonth()+1:'0'+(date.getMonth()+1);
            let day = date.getDate()>9?date.getDate():'0'+(date.getDate());
            return year+'年'+month+'月'+day+'日'
        },
        editYuGuFree(){
            this.isEditFree = true;
        },
        async blurYuGuFee(row){
            console.log(row);
            let res = await api.updateAssetsYuGuFee({
                id:row.id,
                yuGuFee:parseFloat(row.yuGuFee)
            });
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '更新成功!'
                });
                this.isEditFree=false;
            }
        },
        createEntrust(row){
            console.log(row);
            if(row.assetsType == 1){
                this.$router.push({
                    name:'entrustMaterial',
                    query:{
                        caseNo:row.fileNo,
                    }
                });
            }else if(row.assetsType == 2){
                this.$router.push({
                    name:'entrustCar',
                    query:{
                        caseNo:row.fileNo,
                    }
                });
            }
            else if(row.assetsType == 3){
                this.$confirm('下载委托书模板类型', '提示', {
                    confirmButtonText: '物损',
                    cancelButtonText: '车损',
                    type: 'warning'
                }).then(() => {
                    this.$router.push({
                        name:'entrustMaterial',
                        query:{
                            caseNo:row.fileNo,
                        }
                    });
                }).catch(() => {
                    this.$router.push({
                        name:'entrustCar',
                        query:{
                            caseNo:row.fileNo,
                        }
                    });   
                });
            }
            else if(row.assetsType == 4){
                this.$message({
                    message: '财产险没有委托书',
                    type: 'warning'
                });
            }
            else if(row.assetsType == 5){
                this.$router.push({
                    name:'entrustCarInsurance',
                    query:{
                        caseNo:row.fileNo,
                    }
                });
            }else{
                this.$message({
                    message: '没有委托书',
                    type: 'warning'
                });
            }
        },

        
        // 下载excel
        async exportExcel(){
            let option = {
                // Word:this.conditionData.Word,
                // Operator:this.conditionData.Operator,
                // AssetsTypes:JSON.stringify(this.conditionData.AssetsTypes),
                // AssetsStates:JSON.stringify(this.conditionData.AssetsStates),
                // CrimeCity:this.conditionData.CrimeCity,
                // IsZCPG:this.conditionData.IsZCPG,
                // AssetsCaseType:this.conditionData.AssetsCaseType,
                // MechanismId:this.conditionData.MechanismId,
                // Mechanism:this.MechanismName

                Word:this.conditionData.Word,
                AssetsCaseType:this.conditionData.AssetsCaseType,
                AssetsTypes:JSON.stringify(this.conditionData.AssetsTypes),
                MechanismId:this.conditionData.MechanismId,
                Operator:this.conditionData.Operator,
                AssetsStates:this.conditionData.AssetsState?JSON.stringify([this.conditionData.AssetsState]):'[]',
                CrimeCity:this.conditionData.CrimeCity,
                IsZCPG:this.conditionData.IsZCPG,
                startTime:this.conditionData.startTime,
                endTime:this.conditionData.endTime,
                FinancialState:this.conditionData.FinancialState,
                Mechanism:this.MechanismName
            }
            let res = await api.export({
                type:1,
                condition:option
            },'调查案件列表');
        },
    }
    
}
</script>

<style lang="scss" scoped>
    
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        border-radius: 5px;
        padding: 10px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            padding: 5px;
            .label{
                min-width: 110px;
            }
            .input{
                width: 215px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
            /deep/.el-tabs__header{
                margin: 0;
            }
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }

    .dialog{
        height: 100%;
        .item{
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            .label{
                margin-bottom: 5px;
                width: 100px;
            }
            .value{
                width: 215px;
            }
            .textarea{
                width: 630px;
            }
        }
        
        .dialog-footer{
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
    }
</style>
